class Services {
    constructor() {
        document.querySelector('.services').classList.add('collapse');
        
        let groupService = document.querySelectorAll('.group-service');

        groupService.forEach((group) => {
            let tabLinks = group.querySelectorAll('.tab-anchor');
            let tabs = group.querySelector('.contents-service');
            
            tabLinks.forEach(function(tabLink){
                tabLink.addEventListener("click", function(){
                    let targetClick = this.dataset.tab;
                    let tabLinkActive = group.querySelector('.tab-anchor.active');
                    let tabActive = tabs.querySelector('.active');
                    let tabContent = group.getElementsByClassName(targetClick);

                    tabActive.classList.remove('active');
                    tabContent[0].classList.add('active');
                    tabLinkActive.classList.remove('active');
                    this.classList.add('active');
                })
            })
        })
        
        const changeNav = (entries, observer) => {
            entries.forEach((entry) => {
                
                if(entry.isIntersecting && entry.intersectionRatio >= 0.25) {
                    setTimeout(() => {
                        let itenActive = document.querySelector('.menu-services .active');
                        if(itenActive){
                            itenActive.classList.remove('active');
                        }
                        let id = entry.target.getAttribute('id');
                        let currentLink = document.querySelector(`[href="#${id}"]`);
                        currentLink.classList.add('active');
                        
                        let viewportOffset = currentLink.getBoundingClientRect();
                        let elOffsetLeft = viewportOffset.left;
                        document.querySelector('.menu-services ul').scrollLeft = elOffsetLeft-15;                        
                    }, isMobileSize?1100:0);
                }
            })
        }

        const options = {
            threshold: 0.25
        }
        const observer = new IntersectionObserver(changeNav, options);

        const sections = document.querySelectorAll('.page-services .group-service');
        sections.forEach((section) => {
            observer.observe(section);
        })

        function isMobileSize(){
            if (window.matchMedia("(max-width: 1024px)").matches) {
              return true;
            } else {
                return false;
            }
        }

        console.log('Services');
    }
}

export default Services;